import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { ProtectAPi } from "../../../../api/ProtectAPi";
import AdminQuickNav from "../AdminQuickNav";
import BackButton from "../../../tools/BackButton";

const Orderedit = () => {
  const { http } = ProtectAPi();
  const { id } = useParams();
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [status, setStatus] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [loading, setLoading] = useState(false);
  /* ================= FETCH ORDER ================= */
  useEffect(() => {
    http.get(`/order-edit/${id}`)
      .then(res => {
        if (res.data.success) {
          setOrder(res.data.data);
          setStatus(res.data.data.status);
          setPaymentStatus(res.data.data.payment_status);
        }
      })
      .catch(() => {
        swal("Error", "Order not found", "error");
        navigate("/admin/order-list");
      });
  }, [id, navigate]);

  /* ================= UPDATE ================= */
  const updateOrder = () => {
    setLoading(true);

    http.post(`/order-update/${id}`, {
      status,
      payment_status: paymentStatus
    })
      .then(res => {
        setLoading(false);

        if (res.data.success) {
          swal("Success", "Order updated successfully", "success")
            .then(() => navigate("/admin/order-list"));
        } else {
          swal("Error", "Update failed", "error");
        }
      })
      .catch(() => {
        setLoading(false);
        swal("Error", "Update failed", "error");
      });
  };

  if (!order) return null;

  return (
    <div className="main-content" style={{ marginTop: -20 }}>
      <section className="section">
        <AdminQuickNav active="orders" />

        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between">
              <h5>Edit Order</h5>
              <BackButton />
            </div>

            {/* ===== READ ONLY INFO ===== */}
            <div className="row mt-3">
              <div className="col-md-6">
                <label>Order Number</label>
                <input className="form-control" value={order.order_number} disabled />
              </div>

              <div className="col-md-6">
                <label>Customer Name</label>
                <input className="form-control" value={order.customer_name} disabled />
              </div>

              <div className="col-md-6 mt-3">
                <label>Phone</label>
                <input className="form-control" value={order.phone} disabled />
              </div>

              <div className="col-md-6 mt-3">
                <label>Total</label>
                <input className="form-control" value={order.total} disabled />
              </div>
            </div>

            {/* ===== EDITABLE ===== */}
            <div className="row mt-4">
              <div className="col-md-6">
                <label>Status</label>
                <select
                  className="form-control"
                  value={status}
                  onChange={e => setStatus(e.target.value)}
                >
                  <option value="pending">Pending</option>
                  <option value="confirmed">Confirmed</option>
                  <option value="processing">Processing</option>
                  <option value="shipped">Shipped</option>
                  <option value="delivered">Delivered</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>

              <div className="col-md-6">
                <label>Payment Status</label>
                <select
                  className="form-control"
                  value={paymentStatus}
                  onChange={e => setPaymentStatus(e.target.value)}
                >
                  <option value="unpaid">Unpaid</option>
                  <option value="paid">Paid</option>
                </select>
              </div>
            </div>

            {/* ===== BUTTON / LOADER ===== */}
            <div className="col-md-12 p-0 mt-4 mb-4">
              {!loading ? (
                <button
                  type="button"
                  onClick={updateOrder}
                  className="btn btn-lg btn-primary"
                >
                  Update Order
                </button>
              ) : (
                <div className="spinner-border text-dark" role="status"></div>
              )}
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Orderedit;
